import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import { safeGetItem } from "./lib/safeStorage";

const validLangs = ["en", "es", "fr"];
const stored = safeGetItem("db-lang");
const lng = stored && validLangs.includes(stored) ? stored : "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
    },
    lng,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
